import { AppRoutes } from '@consts/routes';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useStyles } from '../Tickets.styles';
import { useQuery } from '@hooks/useQuery';
import { TicketContainer } from '../TicketContainer';
import { LandingEffects } from './LandingEffects';

export const TicketsLanding = () => {

    const navigate = useNavigate();
    const classes = useStyles();
    const query = useQuery();

    return (
      <TicketContainer>
      <LandingEffects />

        <Typography textAlign={'center'} variant='h4'>Having trouble? Select an option below.</Typography>
        <Box className={classes.buttonBox}>
            <Button
              fullWidth
              sx={{ maxWidth: '300px' }}
              variant='contained'
              color='primary'
              href={'https://www.moutfitters.com/rapidcut-training-mini/'}
            >
              Training Resources
            </Button>
            {/** Make sure that the troubleshooter dead ends
             *  back into this vs supplying a QR code for the
             * google form */}
            <Button
                fullWidth
                sx={{ maxWidth: '300px' }}
                variant='contained'
                color='primary'
                href={'https://zingtree.com/live/568949117'}
            >
              Self Troubleshoot
            </Button>

            <Button
                fullWidth
                sx={{ maxWidth: '300px' }}
                variant='contained'
                color='primary'
                onClick={() => navigate(`${AppRoutes.TicketForm}?${query.toString()}`)}>
                Open a ticket
            </Button>
        </Box>
        </TicketContainer>
    );
};
